import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LessonAttachments = ({ attachments = [] }) => {
  // Função para formatar tamanho do arquivo
  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
  };

  // Função para obter ícone baseado no tipo de arquivo
  const getFileIcon = (mimeType, filename) => {
    if (mimeType?.includes('pdf') || filename?.toLowerCase().endsWith('.pdf')) {
      return 'FileText';
    }
    if (mimeType?.includes('word') || filename?.toLowerCase().match(/\.(doc|docx)$/)) {
      return 'FileText';
    }
    if (mimeType?.includes('excel') || filename?.toLowerCase().match(/\.(xls|xlsx)$/)) {
      return 'FileSpreadsheet';
    }
    if (mimeType?.includes('powerpoint') || filename?.toLowerCase().match(/\.(ppt|pptx)$/)) {
      return 'Presentation';
    }
    if (mimeType?.includes('image') || filename?.toLowerCase().match(/\.(jpg|jpeg|png|gif|svg)$/)) {
      return 'Image';
    }
    return 'File';
  };

  // Função para obter cor do ícone baseado no tipo
  const getFileIconColor = (mimeType, filename) => {
    if (mimeType?.includes('pdf') || filename?.toLowerCase().endsWith('.pdf')) {
      return 'text-red-500';
    }
    if (mimeType?.includes('word') || filename?.toLowerCase().match(/\.(doc|docx)$/)) {
      return 'text-blue-500';
    }
    if (mimeType?.includes('excel') || filename?.toLowerCase().match(/\.(xls|xlsx)$/)) {
      return 'text-green-500';
    }
    if (mimeType?.includes('powerpoint') || filename?.toLowerCase().match(/\.(ppt|pptx)$/)) {
      return 'text-orange-500';
    }
    return 'text-gray-500';
  };

  // Se não há anexos, mostrar estado vazio
  if (!attachments || attachments.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 px-6 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
          <Icon name="BookOpen" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium text-foreground mb-2">
          Nenhum arquivo disponível
        </h3>
        <p className="text-sm text-muted-foreground">
          Este vídeo não possui arquivos associados.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {attachments.map((attachment) => {
        const fileInfo = attachment.media_library;
        const filename = fileInfo?.filename || attachment.title || 'Arquivo';
        const fileSize = fileInfo?.size_bytes;
        const mimeType = fileInfo?.mime_type;
        const downloadUrl = fileInfo?.url || attachment.library_url;
        const isLink = attachment.media_type === 'link';

        return (
          <div
            key={attachment.id}
            className="flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-micro"
          >
            <div className="flex items-center space-x-3 flex-1 min-w-0">
              <div className={`flex-shrink-0 ${getFileIconColor(mimeType, filename)}`}>
                <Icon 
                  name={getFileIcon(mimeType, filename)} 
                  size={20} 
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">
                  {filename}
                </p>
                {fileSize && (
                  <p className="text-xs text-muted-foreground">
                    {formatFileSize(fileSize)}
                  </p>
                )}
                {attachment.title && attachment.title !== filename && (
                  <p className="text-xs text-muted-foreground truncate">
                    {attachment.title}
                  </p>
                )}
              </div>
            </div>

            <Button
              variant="outline"
              size="sm"
              iconName={isLink ? "ExternalLink" : "Download"}
              iconPosition="left"
              iconSize={14}
              onClick={() => {
                if (downloadUrl) {
                  window.open(downloadUrl, '_blank');
                }
              }}
              className="flex-shrink-0"
            >
              {isLink ? 'Acessar' : 'Baixar'}
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default LessonAttachments;
